import { PageHeader } from 'components/page-header/page-header'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslate, useWindowDimensions } from 'utils'
import { useConfig, useCustomers } from 'api'
import { useNavigate } from 'react-router-dom'
import { VerticalPaginatedList } from 'components/vertical-paginated-list/vertical-paginated-list'
import { useEffect, useState } from 'react'
import { PageContentWrapper, VerticalContainer } from 'components/styled'
import { theme } from 'antd'
import { FormSection } from 'components/form-section/form-section'
import { CustomerItem } from 'components/customer/location-item/customer-item'
import { Feature } from 'types'

export const CustomersList = () => {

    //hooks:
    const { token: { paddingMD, marginXXS, margin, padding } } = theme.useToken()
    const { SM } = useWindowDimensions()
    const { __ } = useTranslate()
    const { data: config } = useConfig()
    const navigate = useNavigate()

    useEffect(() => {
        if(config && !config.features.includes(Feature.CUSTOMER_MANAGEMENT)){
            navigate('/')
        }
    }, [config])

    //state:
    const [ searchCustomers, setSearchCustomers ] = useState<string | null>(null)
    
    //api:
    const {
        data: customers,
        pageNum,
        totalPages,
        isLoading,
        isPreviousData,
        isNextDisabled,
        isPreviousDisabled,
        fetchNext,
        fetchPrevious
    } = useCustomers(searchCustomers)

    return !config ? null : (
        
        <PageContentWrapper>

            <VerticalContainer style={{ gap: SM ? margin : marginXXS }}>

                {/* header */}
                <PageHeader
                    title={__`customers`}
                    description={__`you_can_manage_your_customers_here`}
                    primaryButton={{
                        name: SM ? __`create_customer` : __`create`,
                        icon: <PlusOutlined/>,
                        onClick: () => navigate('/customer/new')
                    }}
                />

                <div style={{ padding: SM ? `0 ${padding}px` : 0 }}>
                
                    <FormSection
                        title={SM ? __`customers` : undefined }
                        childrenWrapperStyle={{ padding: SM ? `0 ${paddingMD}px` : 0 }}
                        searchInput={{
                            placeholder: __`search_customers`,
                            onSearch: setSearchCustomers
                        }}
                    >

                        {/* list */}
                        <VerticalPaginatedList
                            isFirstLoading={isLoading}
                            isForbidden={customers === null}
                            isError={customers === false}
                            notFound={(customers && customers.length === 0) ?? false}
                            totalPages={totalPages}
                            pageNum={pageNum}
                            isPreviousData={isPreviousData}
                            isNextDisabled={isNextDisabled}
                            isPreviousDisabled={isPreviousDisabled}
                            fetchNext={fetchNext}
                            fetchPrevious={fetchPrevious}
                        >
                            {customers && customers?.map(customer => (
                                <CustomerItem
                                    key={customer.id}
                                    customer={customer}
                                />
                            ))}
                        </VerticalPaginatedList>

                    </FormSection>

                </div>

            </VerticalContainer>

        </PageContentWrapper>
    )
    
}
